import React from 'react'
import CommonBanner from "../components/Common Banner Component/HeroBanner"
import TestimonialForm from '../components/TestimonialForm/TestimonialForm'
import { CheckCircle, Calendar, MessageSquare, ArrowRight, ShieldCheck } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header/Header';


function ThankYou({type="inquiry"}) {
  return (
    <>
    <Header/> 
        {/* <CommonBanner
          subHeading=""
          Heading={`Thank You! We've received your ${type}`}
          spanHeading=""
       
          btnText=""
          bgImg="/images/creative/contact-bg.webp"
          btn={false}
        /> */}

        <ThankYouComponent/>
        <TestimonialForm PartnerCompaniesSection={false}/>
    </>
  )
}

export default ThankYou

const ThankYouComponent = ({  }) => {
const { id } = useParams();
  const navigate = useNavigate()
  const styles = {
    wrapper: {
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: "'Segoe UI', Roboto, sans-serif"
    },
    card: {
      maxWidth: '700px',
      width: '100%',
      backgroundColor: '#ffffff',
      borderRadius: '24px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      overflow: 'hidden',
      border: '1px solid #e2e8f0'
    },
    headerBar: {
      height: '8px',
      background: 'linear-gradient(90deg, #0d9488 0%, #0f172a 100%)' // Teal to Navy
    },
    content: {
      padding: '40px 30px',
      textAlign: 'center'
    },
    iconCircle: {
      width: '80px',
      height: '80px',
      backgroundColor: '#f0fdfa',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 24px auto'
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '20px',
      marginTop: '40px'
    },
    stepCard: {
      padding: '24px',
      backgroundColor: '#f8fafc',
      borderRadius: '16px',
      border: '1px solid #f1f5f9'
    },
    primaryBtn: {
      backgroundColor: '#0f172a',
      color: 'white',
      padding: '12px 32px',
      borderRadius: '50px',
      border: 'none',
      fontWeight: '600',
      cursor: 'pointer',
      fontSize: '16px',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.2s'
    }
  };

  let title= "";
  let content = "";

  switch (id) {
    case "BusinessTaxDiscussion":
        title= "Consultation Request Received";
        content= "Thank you for reaching out to discuss your business tax strategy. One of our specialists will review your request and contact you shortly."
      break;
    case "PersonalTaxFiling":
        title= "Booking Request Confirmed";
        content= "Your request for a personal tax filing appointment has been received."
      break;
    case "DocumentsDropoffPersonalTax":
       title= "See You at the Office";
    content= "Your drop-off appointment is being processed. We look forward to seeing you soon."
      break;
    case "CorporateTaxFiling":
       title= "Corporate Booking Received";
    content="We have received your request for a corporate tax filing session. Our corporate team will reach out to you shortly."
      break;
    case "NewClientMeeting":
         title= "Let’s Get Started";
    content= "Thank you for your interest in our services. Your request for an introductory meeting has been logged, and we will be in touch with you shortly."
      break;
  
    default:
       title= "Inquiry Received";
    content= "Thank you! Your details have been successfully routed to our accounting team. We’ll be in touch shortly."
      break;
  }
 
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div style={styles.headerBar} />
        
        <div style={styles.content}>
          <div style={styles.iconCircle}>
            <CheckCircle size={40} color="#0d9488" />
          </div>

          <h1 style={{ fontSize: '32px', color: '#0f172a', marginBottom: '16px', fontWeight: '800' }}>
            {title}
          </h1>
          
          <p style={{ fontSize: '18px', color: '#475569', lineHeight: '1.6', maxWidth: '500px', margin: '0 auto' }}>
            {content}
          </p>

          <div style={styles.grid}>
            <div style={styles.stepCard}>
              <Calendar size={24} color="#0d9488" style={{ marginBottom: '12px' }} />
              <h3 style={{ margin: '0 0 8px 0', fontSize: '18px' }}>Mark Date</h3>
              {/* <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>Check your calendar for our meeting invite.</p> */}
            </div>

            <div style={styles.stepCard}>
              <MessageSquare size={24} color="#0d9488" style={{ marginBottom: '12px' }} />
              <h3 style={{ margin: '0 0 8px 0', fontSize: '18px' }}>Stay Tuned</h3>
              {/* <p style={{ margin: 0, fontSize: '14px', color: '#64748b' }}>We typically respond within 1 business hour.</p> */}
            </div>
          </div>

          <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'center', gap: '20px', alignItems: 'center' }}>
            <button 
              style={styles.primaryBtn}
              onMouseOver={(e) => e.target.style.backgroundColor = '#1e293b'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#0f172a'}
              onClick={()=>{navigate("/")}}
            >
              Return Home
            </button>
            <a onClick={()=>{navigate("/about")}} style={{ color: '#64748b', textDecoration: 'none', fontSize: '14px', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px', cursor:'pointer' }}>
              About Us <ArrowRight size={16} />
            </a>
          </div>
        </div>

        <div style={{ padding: '20px', backgroundColor: '#f8fafc', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
           {/* <ShieldCheck size={16} color="#94a3b8" /> */}
           <span style={{ fontSize: '12px', color: '#94a3b8', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
             Lotus Accounting 
             {/* • Secure & Confidential */}
           </span>
        </div>
      </div>
    </div>
  );
};
